// @ts-nocheck
import {Column} from 'react-table'
import {PartyActionsCell} from './PartyActionsCell'
import {PartyCustomHeader} from './PartyCustomHeader'
import {Party} from '../../core/_models'
import PartyAmountInfoCell from './PartyAmountInfoCell'

const PartysColumns: ReadonlyArray<Column<Party>> = [
  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Party Code' className='min-w-125px' />
    ),
    accessor: 'party_code',
    Cell: ({value}) => value,
  },
  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Party Name' className='min-w-125px' />
    ),
    accessor: 'party_name',
  },
  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='City' className='min-w-125px' />
    ),
    accessor: 'city_name',
    Cell: ({value}) => value,
  },
  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Vatav' className='min-w-125px' />
    ),
    accessor: 'party_vatav',
    Cell: ({value}) => value,
  },
  {
    Header: (props) => <PartyCustomHeader tableProps={props} title='Gen' className='min-w-125px' />,
    accessor: 'party_current_balance',
    Cell: ({value}) => <PartyAmountInfoCell value={value} />,
  },

  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Receiver Limit' className='min-w-125px' />
    ),
    accessor: 'party_lena_limit',
    Cell: ({value}) => <PartyAmountInfoCell value={value} />,
  },

  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Sender Limit' className='min-w-125px' />
    ),
    accessor: 'party_dena_limit',
    Cell: ({value}) => <PartyAmountInfoCell value={value} />,
  },
  {
    Header: (props) => (
      <PartyCustomHeader tableProps={props} title='Actions' className='text-center min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <PartyActionsCell id={props.data[props.row.index].id} data={props.data[props.row.index]} />
    ),
  },
]

export {PartysColumns}
